import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MemberService } from '../services/member.service';
import { map, take } from 'rxjs/operators';

export const agentGuard: CanActivateFn = () => {
    const memberService = inject(MemberService);
    const router = inject(Router);

    return memberService.isAgent$.pipe(
        take(1),
        map(isAgent => {
            if (isAgent) {
                return true;
            }
            return router.createUrlTree(['establishment', 'dashboard']);
        }),
    );
};
